/**
 * Placeholder for hidden block.
 */

import { Box, type BoxProps } from '@mui/material'
import type { RenderElementPropsExt } from '@tunasong/plugin-lib'

type HiddenBlockProps = Omit<RenderElementPropsExt, 'element'> &
  Omit<BoxProps, 'component' | 'children' | 'border'> & {
    text?: string
  }

export const HiddenBlock = ({ text = 'Hidden', children, ...restProps }: HiddenBlockProps) => (
  <Box
    sx={{
      position: 'absolute',
      right: theme => theme.spacing(1),
      color: 'text.disabled',
      fontStyle: 'italic',
      fontSize: '0.5rem',
    }}
    {...restProps}
  >
    {text}
    <Box sx={{ display: 'none' }}>{children}</Box>
  </Box>
)
